import { AlertTriangle, X } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";

interface UnderConstructionBannerProps {
  message?: string;
}

export function UnderConstructionBanner({ 
  message = "Site em construção — poderá encontrar alguns erros nas páginas ou na escrita." 
}: UnderConstructionBannerProps) {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  return (
    <div className={cn(
      "relative bg-gradient-to-r from-warning/90 to-warning",
      "text-warning-foreground py-2.5 px-4",
      "shadow-sm"
    )}>
      <div className="container mx-auto flex items-center justify-center gap-3 text-sm font-medium">
        <AlertTriangle className="h-4 w-4 flex-shrink-0 animate-pulse" />
        <span className="text-center">{message}</span>
        <button
          onClick={() => setIsDismissed(true)}
          className="absolute right-4 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-black/10 transition-colors"
          aria-label="Fechar aviso"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
